const onecommConfigurations = window['onecommConfigurations' as any] as any

export const IDENTITY_CONFIG = {
    authority: onecommConfigurations.REACT_APP_AUTH_URL, 
    client_id: onecommConfigurations.REACT_APP_IDENTITY_CLIENT_ID, //(string): Your client application's identifier as registered with the OIDC provider.
    redirect_uri: onecommConfigurations.REACT_APP_REDIRECT_URL + 'auth/code', //The URI of your client application to receive a response from the OIDC provider.
    response_type: "code",
    scope: "openid profile",
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
};

export const METADATA_OIDC = {
    issuer: onecommConfigurations.REACT_APP_AUTH_URL,
    jwks_uri: onecommConfigurations.REACT_APP_AUTH_URL + "/pf/JWKS",
    authorization_endpoint: onecommConfigurations.REACT_APP_AUTH_URL + "/as/authorization.oauth2",
    token_endpoint: onecommConfigurations.REACT_APP_AUTH_URL + "/as/token.oauth2",
    userinfo_endpoint: onecommConfigurations.REACT_APP_AUTH_URL + "/idp/userinfo.openid",
    end_session_endpoint: onecommConfigurations.REACT_APP_AUTH_URL + "/idp/startSLO.ping",
};